import {Chart} from "react-google-charts"
export const StackedChart=(props)=>{
  console.log(props.data)
  return ( 
   <>
   <Chart
          width={"100%"}
          height={"400px"}
          chartType="ColumnChart"
          loader={<div>Loading Chart</div>}
          data={props.data}
          options={{
           
            legend: { position: "bottom",textStyle:{
                color:"white"
            }},
            isStacked: true,
            backgroundColor:"transparent",
            vAxis: {
              textStyle:{
                    color:"white"
                },
                gridlines:{
                  color:"transparent",
                  
                  },
            },
            hAxis: {
               gridlines:{
                color:"transparent",
                },
                textStyle:{
                    color:"white"
                }
            },
            bars: "vertical",
          
            colors: ["#3cd2a5","red"]
          }}
        
        />
   </>
  )
}
